module.exports = __webpack_public_path__ + "img/loader.9155f9f9.png";